<template src="./AlertChart.html"></template>
<style lang="scss" src='./AlertChart.scss' scoped></style>


<script>
  import {
    mapState
  } from 'vuex';
  import ApexChart from 'vue-apexcharts'
  import {
    getSensorGraph,
    getSensor
  } from '@/api/index';

  let CounterForUpdates = 0;

  export default {
    components: {
      ApexChart,
    },
    watch: {
      seriesData() {
        this.UpdateData()
      }
    },
    data() {
      return {
        series: [{
          data: []
        }],
        charOpt: {
          xaxis: {
            type: 'datetime',
          },
        },
        optionSelected: null,
        options: [{
            label: 'Last 24 Hours',
            value: 1,
            resampleFreq: "30min"
          },
          {
            label: 'Last 2 Days',
            value: 2,
            resampleFreq: "2h"
          },
          {
            label: 'Last Week',
            value: 7,
            resampleFreq: "4h"
          },
          {
            label: 'Last Month',
            value: 30,
            resampleFreq: "12h"
          },
        ],
        loading: true,
      }
    },

    computed: {
      noDataMessage() {
        let message = 'No data to display in the ';
        return message + this.optionSelected.label.toLowerCase();
      },
      ...mapState('Dashboard', {
        alert: (state) => state.selectedAlert,
      }),
    },
    methods: {

      async getGraph() {
        this.loading = true;
        let tempChartOptions = this.getChartOptions();
        this.alertType = this.consts.AlertType[this.alert.alert_type_id];
        this.unitOfMeasurament = this.G_getUOM({
          uom: this.alertType.uom
        });
        tempChartOptions.title.text = this.alertType.i18n + ' data';
        tempChartOptions.yaxis.title.text = this.unitOfMeasurament;
        const data = {
          sensorId: this.alert.sensor_id,
          alias: this.alertType.alias,
          until: this.optionSelected.value,
          resampleFreq: this.optionSelected.resampleFreq,
        };
        let tempMin = null;
        let tempMax = null;
        await getSensorGraph(data).then((res) => {
          let tempSeries = [];
          if (res.length > 0) {

            tempSeries = res.map((item) => {

              let reading = this.G_getMeasurement({
                  val: item[data.alias],
                  uom: this.alertType.uom,
                  addUnit: false,
                  invertUOM: false
                })

              if (tempMin == null) {
                tempMin = Number(reading);
              } else {
                if (Number(reading) < Number(tempMin)) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });
          }
          this.series = [{
            name: this.alertType.i18n,
            data: tempSeries
          }];
        });
        let min = 0;
        let max = 0;
        await getSensor(this.alert.sensor_id).then(sensor => {
          /* Ommit annotations
          if (sensor.threshold && this.alertType.uom !== this.consts.UOM.RSSI) {
            min =
              this.G_getMeasurement({
                val: sensor.threshold[`min_${this.alertType.key}`],
                uom: this.alertType.uom,
                addUnit: false,
                invertUOM: false
              });
            max =
              this.G_getMeasurement({
                val: sensor.threshold[`max_${this.alertType.key}`],
                uom: this.alertType.uom,
                addUnit: false,
                invertUOM: false
              });
            tempChartOptions.annotations.yaxis[0].y = min;
            tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
            tempChartOptions.annotations.yaxis[1].y = max;
            tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
          } else {
            tempChartOptions.annotations.yaxis = [];
          }
          */
        });
        tempChartOptions.annotations.yaxis = [];
        //let yaxisMin = (min < tempMin) ? min : tempMin;
        //tempChartOptions.yaxis.min = (yaxisMin > 0) ? 0 : yaxisMin;
        tempChartOptions.yaxis.min = Number(tempMin);
        //if (tempMax > max) {
        //  tempChartOptions.yaxis.max = tempMax;
        //} else {
        //  tempChartOptions.yaxis.max = max;
        //}
        tempChartOptions.yaxis.max = Number(tempMin) == Number(tempMax) ? Number(tempMax) + 0.05 : Number(tempMax);
        this.charOpt = tempChartOptions;
        this.loading = false;
      },

      getChartOptions() {
        return {
          chart: {
            type: 'area',
            animations: {
              enabled: false,
              // easing: "linear",
              // dynamicAnimation: {
              //   speed: 300
              // },
            },

            stacked: false,
            height: 350,
            zoom: {
              type: 'x',
              enabled: true,
              autoScaleYaxis: true
            },
            toolbar: {
              show: false,
            },
            events: {
              updated: function (chartContext, config) {
                if (CounterForUpdates != 0) {
                  var elmnt = document.getElementById("chart");
                  elmnt.scrollIntoView();
                }
                ++CounterForUpdates;
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 2.5,
            colors: '#018ffb',
            strokeColors: '#018ffb',
            strokeWidth: 0,
          },
          title: {
            text: 'title',
            align: 'left'
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.4,
              opacityTo: 0,
              stops: [0, 90, 100]
            },
          },
          stroke: {
            width: [3]
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val ? (val).toFixed(2) : 0;
              },
            },
            title: {
              text: 'unitOfMeasurament'
            },
            min: -5,
            max: 150,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'h:mm TT',
              },
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: (val) => {
                return this.G_formatDate({date: val, pretty: false});
              }
            },
            shared: false,
            y: {
              formatter: (val) => {
                return val ? `${(val).toFixed(2)}${this.unitOfMeasurament}` : '';
              }
            }
          },
          annotations: {
            yaxis: [{
              y: 10,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Min',
              }
            }, {
              y: 60,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Max',
              }
            }, ],
          }
        }
      },
    },
    mounted() {
      CounterForUpdates = 0;
      this.optionSelected = this.options[0];
      this.getGraph();
    }
  }

</script>
